export enum OverlayButtonVariant {
	TextOnly = 'textOnly',
	TextAndIcon = 'textAndIcon',
	IconMedium = 'iconMedium',
	IconSmall = 'iconSmall',
}

export interface OverlayButtonIconProps extends React.ComponentProps<'button'> {
	readonly variant:
		| OverlayButtonVariant.IconSmall
		| OverlayButtonVariant.IconMedium
		| OverlayButtonVariant.TextAndIcon
	readonly icon: React.ReactNode
}

export interface OverlayButtonTextProps extends React.ComponentProps<'button'> {
	readonly variant: OverlayButtonVariant.TextOnly
}
